/** Replace images, links, and copy with your real assets. Photo URLs are stock placeholders. */

export const CONTACT_EMAIL = 'booking@doublekaudio.com';

export const HERO_IMAGE =
  `${process.env.PUBLIC_URL}/studio.jpg`;

export const STATS = [
  { label: 'Sessions & shows', value: '200+' },
  { label: 'Years behind the desk', value: '15+' },
  { label: 'Custom rigs built and deployed', value: '10+' },
];

export const GALLERY = [
  {
    images: [
      `${process.env.PUBLIC_URL}/racks-1.jpeg`,
      `${process.env.PUBLIC_URL}/racks-2.jpeg`,
      `${process.env.PUBLIC_URL}/racks-3.jpeg`,
      `${process.env.PUBLIC_URL}/racks-4.jpeg`,
      `${process.env.PUBLIC_URL}/racks-5.jpeg`,
    ],
    caption: 'Custom audio racks not only sound better, they\'re more reliable and easier to work with. Our latest rack builds feature wireless mics and IEMs, Dante audio and amazing flexibility.',
    alt: 'Audio rack build',
  },
  {
    images: [
      `${process.env.PUBLIC_URL}/pedalboard-1.jpeg`,
      `${process.env.PUBLIC_URL}/pedalboard-2.jpeg`,
      `${process.env.PUBLIC_URL}/pedalboard-3.jpeg`,
      `${process.env.PUBLIC_URL}/pedalboard-4.jpeg`,
    ],
    caption: 'Pedalboards are where I got started with custom wiring and builds. It\'s such a fun time to work with someone to get the signal chain just right and absolutely nail their guitar tone.',
    alt: 'Guitar pedalboard build',
  },
  {
    images: [
      `${process.env.PUBLIC_URL}/wiring-1.jpeg`,
      `${process.env.PUBLIC_URL}/wiring-2.jpeg`,
      `${process.env.PUBLIC_URL}/wiring-3.jpeg`,
      `${process.env.PUBLIC_URL}/wiring-4.jpeg`,
    ],
    caption: 'Going beyond audio, we also wire networking, build custom MIDI pedals and overall help your team #feelpro.',
    alt: 'Custom audio wiring build',
  },
  {
    src: `${process.env.PUBLIC_URL}/ableton.png`,
    caption: 'Ableton Live is core to our tight sound and overall production. Book now for a consultation on using Ableton in a live setting or help with setting up your templates to be more efficient than ever.',
    alt: 'Ableton Live session',
  },
];

export const SERVICES = [
  {
    title: 'Engineering',
    outcome: 'Great records start with quality recordings',
    blurb:
      'Mic choices, gain structure, headphone balance, and session flow so artists perform instead of fighting the setup. From a modest room to a purpose-built studio, I\'m at home managing your session and ensuring you sound your best.',
    image:
      'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?auto=format&fit=crop&w=900&q=80',
    alt: 'Microphone in recording studio',
  },
  {
    title: 'Mixing',
    outcome: 'Clarity, punch, and emotion — not just loudness.',
    blurb:
      'Stereo and immersive-ready balances with references matched to your genre and release goals.',
    image:
      'https://images.unsplash.com/photo-1520872024865-3ff2805d8acd?auto=format&fit=crop&w=900&q=80',
    alt: 'Studio monitors and mixing desk',
  },
  {
    title: 'Rig building',
    outcome: 'Repeatable nights — fewer surprises, faster line checks.',
    blurb:
      'Routing, configuration and solid wiring to ensure your show is seamless and reliable.',
    image:
      'https://images.unsplash.com/photo-1506157786151-b8491531f063?auto=format&fit=crop&w=900&q=80',
    alt: 'Live concert stage with lighting',
  },
];

/** Self-hosted clips. Drop files in `public/audio/` and reference as `/audio/file.mp3`. */
export const AUDIO_EXAMPLES = [
  {
    title: 'Thousand Pounder - The Others 15 Year',
    detail: 'Remixed for 15 year anniversary release, focused on impact, clarity and feel.',
    src: '/audio/thousand-pounder-the-others.mp3',
  },
  {
    title: 'AJB - Fresh to Dead',
    detail: 'Nerdcore Rap from Columbus, OH.',
    src: '/audio/ajb-fresh-to-dead.mp3',
  },
  {
    title: 'Say.Goodnight. - I Already Don\'t Like Tomorrow And It\'s Not Even Today',
    detail: 'My personal project. Luney Award winner.',
    src: '/audio/say-goodnight-already.mp3',
  },
];

export const PROJECTS = [
  {
    title: 'Kim Beyer',
    outcome: 'Guitar player, music director, rig manager',
    blurb:
      "I play guitar for local Glam Pop artist Kim Beyer. Over the past 5 years, we've released multiple albums and EPs, played dozens of shows and become great friends.\n\nWe love to put on a show, full of makeup, high-energy and danceable songwriting. You can check out our upcoming shows by clicking on the image above.",
    image: `${process.env.PUBLIC_URL}/kim-beyer.jpg`,
    alt: 'Band performing on stage',
    link: 'https://instagram.com/_kim_beyer_',
  },
  {
    title: 'Say.Goodnight.',
    outcome: 'Rock & Roll for my feelings',
    blurb:
      'Started nearly 20 years ago, this project has been my creative outlet for every cool riff, synth hook and struggle I\'ve been through.\n\nWe regularly play shows around Columbus, OH and are always down for a good time. Find us on Instagram @saygoodnightband.',
    image: `${process.env.PUBLIC_URL}/say-goodnight.jpg`,
    alt: 'Say.Goodnight. live',
    link: 'https://instagram.com/saygoodnightband',
  },
  {
    title: 'AJB',
    outcome: 'Producer, MD and hype man.',
    blurb:
      'AJB plays drums in my other projects and is an unbelievably talented rapper. Starting with VPC7, I have been working with AJB on original tracks and performing live.\n\nWe\'re currently working on tracks for VPC8 and can\'t wait to share them with you!',
    image: `${process.env.PUBLIC_URL}/ajb.jpg`,
    alt: '',
    link: 'https://instagram.com/soundlikeajb',
  },
];

/** Rotates on a timer in the UI — add or reorder entries here. */
export const TESTIMONIALS = [
  {
    quote:
      'Kyle brings decades of multimedia experience and knowledge to the table. His expertise with vocal coaching and layering tracks allows my music to shine. I always leave the studio feeling confident and excited for the next steps in song production. He’s extremely patient, provides feedback when warranted, and delicately guides you through the process of recording. I would recommend Kyle Kurz to any singer/songwriter who is looking to book studio time for an upcoming record.',
    attribution: 'Huge Euge, Nerdcore artist',
  },
  {
    quote:
      'I came to Kyle with a pretty beat up, unorganized IEM rig, and he completely turned it around. He rerouted everything, cleaned it up, labeled it, and made sure I actually understood how it all worked. It’s been a huge game changer for my setup, and my live shows run way smoother now. Love this guy!',
    attribution: 'Sarah Cowan, alt/pop artist',
  },
  {
    quote:
      'Working with Kyle is intuitive and effortless. Listening to his direction will really elevate whatever you\'re wanting to record.',
    attribution: 'Matt Stinnett, Local Celebrity',
  },
];
